import { BlockType, getBlockFormFieldName, IdentificationApplicant } from '@common/entities';
import { ID_TYPE_DONT_HAVE_FIELD_NAME } from '@common/ui';

import { IdentificationConfiguration, IdType, Person } from 'types/fields';

const getEntity = () => {
  // coming soon
  return [];
};

const getFieldsFromIdTypes = (idTypes: IdType[], blockType: BlockType, section: string) => {
  const returnData: any[] = [];
  idTypes.forEach(({ fields, customType }, index) =>
    fields.forEach(({ name: fieldName }) => {
      const blockFieldFormFieldName = ID_TYPE_DONT_HAVE_FIELD_NAME.has(fieldName)
        ? `${BlockType.IdentificationType}.${section}.${index}.dontHaveId`
        : `${BlockType.IdentificationType}.${section}.${index}.${fieldName}`;

      returnData.push({
        blockFieldName: getBlockFormFieldName(
          blockType,
          fieldName,
          `person_${section}_${customType}`,
        ),
        blockFieldFormFieldName,
      });
    }),
  );
  return returnData;
};

const getPersonFields = (data: Person) => {
  const { primaryId, alternateIds, additionalPrimaryId, showCitizenQuestion } = data;

  const citizenQuestionFields = showCitizenQuestion
    ? [
        {
          blockFieldName: getBlockFormFieldName(
            BlockType.IdentificationType,
            'is_us_citizen',
            'person',
          ),
          blockFieldFormFieldName: `${BlockType.IdentificationType}.tax_info_details.is_us_citizen`,
        },
      ]
    : [];

  const primaryFields = getFieldsFromIdTypes(
    primaryId.idTypes,
    BlockType.IdentificationType,
    'primaryId',
  );

  const additionalPrimaryFields = getFieldsFromIdTypes(
    additionalPrimaryId.idTypes,
    BlockType.IdentificationType,
    'additionalPrimaryId',
  );
  const alternateIdFields = getFieldsFromIdTypes(
    alternateIds.idTypes,
    BlockType.IdentificationType,
    'alternateId',
  );

  return [
    ...citizenQuestionFields,
    ...primaryFields,
    ...additionalPrimaryFields,
    ...alternateIdFields,
  ];
};

export const getIdentificationTypeFieldMap = (configuration: IdentificationConfiguration) => {
  const { applicantType, person } = configuration;
  if (applicantType === IdentificationApplicant.Person) {
    return getPersonFields(person as Person);
  }

  return getEntity();
};
